import axios, { AxiosInstance } from "axios";
import {
  API_URL,
  httpCode,
  MY_ACCOUNT_API_URL,
  removeTokensFromLocalStorage,
  USE_SEPARATE_MY_ACCOUNT_API_BASE,
} from "../utils/constants";
import { ApiEndPoints } from "../utils/endpoints";

// Create axios instance
export const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const url = config.url ?? "";
    if (
      USE_SEPARATE_MY_ACCOUNT_API_BASE &&
      MY_ACCOUNT_API_URL &&
      url.startsWith(ApiEndPoints.myaccount)
    ) {
      config.baseURL = MY_ACCOUNT_API_URL;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response?.status === httpCode.UNAUTHORIZED) {
      handleUnauthorizedRepsonse();
    } else {
      return response;
    }
  },
  (error) => {
    if (error?.response?.status === httpCode.UNAUTHORIZED || error?.response?.status === httpCode.ERR_NETWORK) {
      handleUnauthorizedRepsonse();
    }
    if (error?.response?.status === httpCode.FORBIDDEN || error?.response?.status === httpCode.BAD_REQUEST) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const handleUnauthorizedRepsonse = () => {
  removeTokensFromLocalStorage();
  window.location.href = window?.location?.origin;
};
